var render, staticRenderFns
import script from "./ib-table-basic.vue?vue&type=script&lang=js&"
export * from "./ib-table-basic.vue?vue&type=script&lang=js&"
import style0 from "./ib-table-basic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-table-basic.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594ca5a8')) {
      api.createRecord('594ca5a8', component.options)
    } else {
      api.reload('594ca5a8', component.options)
    }
    
  }
}
component.options.__file = "src/components/table/ib-table-basic.vue"
export default component.exports